var CardBrandIconStyle;
(function (CardBrandIconStyle) {
    CardBrandIconStyle["MonochromeLight"] = "monochrome-light";
    CardBrandIconStyle["MonochromeDark"] = "monochrome-dark";
    CardBrandIconStyle["Colored"] = "colored";
})(CardBrandIconStyle || (CardBrandIconStyle = {}));
export default CardBrandIconStyle;
